<template>
  <b-modal
    v-model="show"
    header-class="lmm-common-popup-header"
    :title="dialog.context.title"
    @shown="initMap"
  >
    <div id="map"></div>
    
    <template v-slot:modal-footer>
      <b-btn
          v-if="!dialog.withoutCancel"
          :size="dialog.submit.size"
          @click="cancel"
      >
        {{$t('close')}}
      </b-btn>
    </template>
  </b-modal>
</template>

<script>
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import _ from 'lodash'

const defaultValues = {
  size: 'lg',
  title: '',
  context: '',
  submit: {
    size: 'sm',
    text: 'submit',
    color: 'secondary'
  },
  limit: null,
  placeholder: '',
  textarea: false,
  nullable: false,
  withoutInput: false,
  withoutCancel: false
}

export default {
  name: 'AgentMapDialog',
  data() {
    return {
      latitude: null,
      longitude: null,
      map: null,
      marker: null,
      show: false,
      agentName: null,
      dialog: {},
    };
  },
  created() {
    this.dialog = defaultValues
    this.AppState.$on('show-agent-map-dialog', (params) => {
      this.dialog = _.assignIn({}, defaultValues, params)
      this.show = true
      this.latitude = params.context.latitude
      this.longitude = params.context.longitude
      this.agentName = params.context.agentName
    })
  },
  methods: {
    initMap() {
      this.map = L.map('map').setView([this.latitude, this.longitude], 13);
      
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);
      
      const customIcon = L.icon({
        iconUrl: require('@/assets/marker-icon.png'),
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34]
      });
      
      this.marker = L.marker([this.latitude, this.longitude], {icon: customIcon}).addTo(this.map);
      this.marker.bindPopup(`<b>${this.agentName}</b>`).openPopup();
    },
    cancel () {
      this.show = false
    },
  }
}
</script>

<style scoped lang="scss">
.limit {
  text-align: right;
}
.overlimit {
  color: red;
}


::v-deep .modal-header {
  background-color: #FAFAFA !important;
  padding: 1rem 1rem 0.75rem 1rem;
  h5 {
    font-size: 1.1rem;
    font-weight: 550;
  }
}

::v-deep .modal-footer {
  border: none;
  padding: 0 1rem 1rem 1rem
}

.btn-primary {
  color: white;
  &:hover {
    color: white;
  }
  &:active{
    color: white;
  }
}

.btn-secondary {
  color: #6F6F6F !important;
  background-color: #FFFFFF;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.context {
  font-size: 0.9rem;
  color: #545B64;
}
#map {
  width: 100%;
  height: 600px;
}

::v-deep .modal-dialog {
  max-width: 800px !important;
}
</style>